/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Admin_Manager_Full_AccessInputs */

const en_knp_guide_admin_manager_full_access = /** @type {(inputs: Knp_Guide_Admin_Manager_Full_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin and Manager roles always have full access to all guides.`)
};

const fr_knp_guide_admin_manager_full_access = /** @type {(inputs: Knp_Guide_Admin_Manager_Full_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les rôles Administrateur et Manager ont toujours un accès complet à tous les guides.`)
};

const de_knp_guide_admin_manager_full_access = /** @type {(inputs: Knp_Guide_Admin_Manager_Full_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administratoren und Manager haben stets vollen Zugriff auf alle Leitfäden.`)
};

const it_knp_guide_admin_manager_full_access = /** @type {(inputs: Knp_Guide_Admin_Manager_Full_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I ruoli di amministratore e gestore hanno sempre accesso completo a tutte le guide.`)
};

const ru_knp_guide_admin_manager_full_access = /** @type {(inputs: Knp_Guide_Admin_Manager_Full_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Администраторы и менеджеры всегда имеют полный доступ ко всем руководствам.`)
};

const es_knp_guide_admin_manager_full_access = /** @type {(inputs: Knp_Guide_Admin_Manager_Full_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los roles de administrador y gerente siempre tienen acceso completo a todas las guías.`)
};

const zh_cn2_knp_guide_admin_manager_full_access = /** @type {(inputs: Knp_Guide_Admin_Manager_Full_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理员和经理角色始终拥有所有指南的完整访问权限。`)
};

const ja_knp_guide_admin_manager_full_access = /** @type {(inputs: Knp_Guide_Admin_Manager_Full_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理者およびマネージャーの役割には、常にすべてのガイドへのフルアクセス権が付与されます。`)
};

const hi_knp_guide_admin_manager_full_access = /** @type {(inputs: Knp_Guide_Admin_Manager_Full_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एडमिन और मैनेजर पदों पर कार्यरत व्यक्तियों को हमेशा सभी गाइडों तक पूर्ण पहुंच प्राप्त होती है।`)
};

const pt_pt2_knp_guide_admin_manager_full_access = /** @type {(inputs: Knp_Guide_Admin_Manager_Full_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os cargos de Administrador e Gerente sempre têm acesso completo a todos os guias.`)
};

/**
* | output |
* | --- |
* | "Admin and Manager roles always have full access to all guides." |
*
* @param {Knp_Guide_Admin_Manager_Full_AccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_admin_manager_full_access = /** @type {((inputs?: Knp_Guide_Admin_Manager_Full_AccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Admin_Manager_Full_AccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_admin_manager_full_access(inputs)
	if (locale === "de") return de_knp_guide_admin_manager_full_access(inputs)
	if (locale === "it") return it_knp_guide_admin_manager_full_access(inputs)
	if (locale === "ru") return ru_knp_guide_admin_manager_full_access(inputs)
	if (locale === "es") return es_knp_guide_admin_manager_full_access(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_admin_manager_full_access(inputs)
	if (locale === "ja") return ja_knp_guide_admin_manager_full_access(inputs)
	if (locale === "hi") return hi_knp_guide_admin_manager_full_access(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_admin_manager_full_access(inputs)
	return en_knp_guide_admin_manager_full_access(inputs)
});